import script from "./DynamicTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicTable.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicTable.vue?vue&type=style&index=0&id=2cb16cee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb16cee"]])

export default __exports__